<div [class]="skinName">
  @if (!showSuccess) {
    <h2 class="uk-modal-title">{{ configService.localeKeys?.['account.edit_name.text'] || 'Edit Your Name' }}</h2>
  }
  @if (!showSuccess) {
    <div class="input-container">
      <form [formGroup]="editUsernameForm" method="post" id="account" enctype="multipart/form-data">
        <div class="input-fields form-group">
          <label class="input-label">{{ configService.localeKeys?.my_acc_edit_name_label || 'Name' }}</label>
          <input id="add-profile-name" class="form-control" placeholder="{{ configService.localeKeys?.['my_account.edit_name.text']}}" type="text" required formControlName="user_name" [(ngModel)]="userName" name="userName">
        </div>
        <input type="type" name="login_by" class="display-none" ng-model="login_by">
        <input type="type" name="u_id" class="display-none" ng-model="profile.u_id">
        <input type="type" name="d_type" class="display-none" ng-model="profile.device_type">
        <button class="uk-button submit-btn" (click)="editAccount()">{{ configService.localeKeys?.['common_keys.save_changes.btn']}}</button>
      </form>
    </div>
  }

  @if (showSuccess) {
    <div class="input-container">
      <app-success [toptext]="successMessage" icon="/branding/theme/assets/static_assets/ic-success.svg" [haslottie]="'true'">
      </app-success>
    </div>
  }

</div>